<!--  -->
<template>
<div :class="['layout',isMobile?'mbg':'bg']">
    <span :class="['back',{'m':isMobile}]" @click="$router.push('/')"><img src="@/assets/images/back-icon.png" alt=""></span>
    <img class="title" v-if="isMobile" src="@/assets/images/title.png" alt="">
   <div :class="['list',{'m':isMobile}]">
       <img v-for="(at,i) in list" :key="i" @click="$router.push({
           path:'/scene',
           query:{
               id:i
           }
       })" :src="require('@/assets/images/'+ (i + 1) +'.png')" alt="">
   </div>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import browser from '@/utils/browser.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {

},
data() {
//这里存放数据
return {
    isMobile:browser.mobile,
    list:[
        {
            img:1,
            link:''
        },{
            img:2,
            link:''
        },{
            img:3,
            link:''
        },{
            img:4,
            link:''
        },{
            img:5,
            link:''
        },
    ]
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
   
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeUnmount() {}, //生命周期 - 销毁之前
unmounted() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
    .layout {
        width:100%;
        height:100%;
        background-position:center center;
        overflow: hidden;
        &.bg {
            background-image:url(../../assets/images/bg.jpg);
            background-size:cover;
        }
        &.mbg {
            background-image:url(../../assets/images/m-bg2.jpg);
            background-size:100% auto;
            background-position:center bottom;
        }
        .title {
            width:83vw;
            position:absolute;
            left:0;
            right:0;
            top:10vh;
            
            margin:auto;
        }
        .list {
            width:36vw;
            margin:13vh auto 0;
            display:flex;
            justify-content: center;
            flex-wrap: wrap;
            &.m {
                position:absolute;
                bottom:10vh;
                left:0;
                right:0;
                margin:auto;
                width:100vw;
                img {
                    flex-shrink:0;
                    width:27.3vw;
                    height:34.53vw;
                    margin:1.2vw;
                }
            }
            img {
                width:8.85vw;
                margin:1.3vw;
            }
        }
        .back {
            display:block;
            position:absolute;
            width:11vw;
            top:2vw;
            right:2vw;
            &.m {
                top:5vw;
                right:4vw;
                width:32.6vw;
            }
        }
    }
</style>